import useApi from '../../hooks/api/useApi';

export function useGetWeeklyCalendarBookings(startDate, endDate, locationId, servicePeriodId) {
  const shouldFetch = startDate && endDate && locationId;

  const url = shouldFetch
    ? `/calendar/booking/weekly?start_date=${startDate}&end_date=${endDate}&location_id=${locationId}${
        servicePeriodId ? `&service_period=${servicePeriodId}` : ''
      }`
    : null;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    bookingsByService: data?.data || {},
    success: data?.success ?? false,
    message: data?.message,
    error,
    isLoading,
    refresh
  };
}

export function useGetMonthlyCalendarBookings(currentMonth, year, locationId, servicePeriodName, search) {
  const shouldFetch = currentMonth && year && locationId;

  const url = shouldFetch
    ? `/bookings/monthly-bookings?current_month=${currentMonth}&year=${year}&location_id=${locationId}${
        servicePeriodName ? `&service_period_name=${encodeURIComponent(servicePeriodName)}` : ''
      }${search ? `&search=${encodeURIComponent(search)}` : ''}`
    : null;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    bookingsByService: data?.data || {},
    success: data?.success ?? false,
    message: data?.message,
    error,
    isLoading,
    refresh
  };
}

export function useGetServicePeriodColors(locationId) {
  const url = locationId ? `/service-periods/colors?location_id=${locationId}` : '/service-periods/colors';

  const { data, error, isLoading } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    colors: data?.data || [],
    isLoading,
    error
  };
}

export function useGetDailyCalendarBookings(date, locationId, servicePeriodId) {
  const shouldFetch = date && locationId;

  const url = shouldFetch
    ? `/bookings/daily?date=${date}&location_id=${locationId}${servicePeriodId ? `&service_period=${servicePeriodId}` : ''}`
    : null;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    bookingsByService: data?.data || {},
    success: data?.success ?? false,
    message: data?.message,
    error,
    isLoading,
    refresh
  };
}
